import { PylotFrontendConfig } from 'config'
import { ProductInterface } from '@pylot-data/fwrdschema'
import { deepValue } from '@corratech/pylot-utils'
import { ProductAttributesSeoConfig } from '@preload/graphql/getConfig.d'

export type AttributeValue = string | number | null | undefined

type GetProductAttributeValue<T = AttributeValue> = (
    product: ProductInterface,
    attribute: keyof ProductAttributesSeoConfig,
    config: PylotFrontendConfig,
    defaultValue?: T
) => T

const isStringArray = (arr: Array<unknown>): arr is string[] => {
    let result = true
    arr.forEach((item) => {
        if (typeof item !== 'string') {
            result = false
        }
    })
    return result
}

export const getProductAttributeValue: GetProductAttributeValue = (
    product,
    configKey,
    config,
    defaultValue = null
) => {
    const configPath = config.seo.product.attributes[configKey]
    if (
        !Array.isArray(configPath) ||
        configPath.length === 0 ||
        !isStringArray(configPath)
    ) {
        return String(defaultValue)
    }
    return deepValue(product, configPath, defaultValue)
}

export const getStringAttributeValue: GetProductAttributeValue<string> = (
    product,
    configKey,
    config,
    defaultValue = ''
): string => {
    return String(
        getProductAttributeValue(product, configKey, config, defaultValue)
    )
}
